<template>
  <div>
    <el-card>
      <div slot="header">
        <span>种植方案</span>
        <el-button
          style="float: right"
          type="primary"
          size="small"
          @click="toSchemeAdd()"
        >
          新建方案
        </el-button>
      </div>
      <el-form size="small" inline>
        <el-form-item>
          <el-input
            placeholder="根据方案名称查询"
            v-model="programmeName"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="varietyId"
            filterable
            size="small"
            placeholder="根据品种查询"
          >
            <el-option
              v-for="(item, index) in varietyList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="searchlist"
          >
            搜索
          </el-button>
        </el-form-item>
      </el-form>
      <el-row :gutter="10" style="min-height: 520px">
        <el-col :span="4" v-for="(item, index) in tableData" :key="index">
          <el-card
            :body-style="{ padding: '6px' }"
            style="margin: 0 0 10px 0; cursor: pointer"
          >
            <el-row>
              <el-col :span="24">
                <h4 style="margin: 4px">{{ item.name }}</h4>
              </el-col>
            </el-row>
            <el-row style="font-size: 13px; line-height: 180%; color: #6f6f6f">
              <el-col :span="24"> 适用品种：{{ item.varietyName }} </el-col>
              <el-col :span="12"> {{ item.phaseCount }}阶段 </el-col>
              <el-col :span="12"> 全程{{ item.duration }}天 </el-col>
              <!-- 暂无字段 -->
              <el-col :span="12"> 第{{ item.plantDay }}天种植 </el-col>
              <el-col :span="12"> {{ item.harvestDay }}天上市 </el-col>
              <el-col :span="24">
                <div
                  style="
                    padding: 6px 0;
                    color: #9f9f9f;
                    height: 72px;
                    overflow-y: hidden;
                  "
                >
                  {{ item.memo }}
                </div>
              </el-col>
              <el-col>
                <el-tooltip effect="dark" content="进入编辑" placement="top">
                  <el-button
                    icon="el-icon-edit"
                    type="success"
                    circle
                    size="large"
                    style="padding: 4px"
                    @click="toSchemeEdit(item.id)"
                  />
                </el-tooltip>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
      <div style="margin-top: 12px; text-align: center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-size="value"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getAllVarieties } from '@/api/variety2.js'
import { getProgrammeData, delProgrammeData } from '@/api/programme.js'
export default {
  name: 'SchemeList',
  data() {
    return {
      programmeId: undefined,
      pageNum: 1,
      value: 12,
      total: 0,
      searchContent: null,
      activate: '3-3',
      tableData: [],
      activeTab: 'newone',
      grammeId: undefined,
      /**
       * 方案名称
       */
      programmeName: undefined,
      programmeNameList: [],
      /**
       * 草莓
       */
      varietyId: undefined,
      varietyList: [],
    }
  },
  computed: {
    title: function () {
      return this.programmeId ? '编辑' : '新增'
    },
    totalDuration: function () {},
  },
  created() {
    /**
     * 获取所有草莓品种
     */
    getAllVarieties().then((r) => {
      this.varietyList = r.data.list
    })
  },
  methods: {
    ProgrammeData() {
      this.enterpriseId = this.$store.getters.currentEnterprise.id
      let option = {
        pageNum: this.pageNum,
        pageSize: this.value,
        enterpriseId: this.enterpriseId,
        fuzzyQueryName: this.programmeName,
      }
      this.programmeId = undefined
      getProgrammeData(option).then((data) => {
        this.programmeNameList = data.data.list

        this.tableData = data.data.list
        console.log(this.tableData)
        this.total = data.data.total
      })
    },
    cancel() {
      // this.$refs.inputAdd.clearFrom()
      // this.programmeId=undefined
      // this.$refs.inputAdd.form.id=undefined
    },
    searchlist() {
      let option = {
        pageNum: this.pageNum,
        pageSize: this.value,
        // enterpriseId: this.enterpriseId,
        fuzzyQueryName: this.programmeName,
        varietyId: this.varietyId,
      }
      getProgrammeData(option).then((data) => {
        this.programmeNameList = data.data.list
        this.tableData = data.data.list
        this.total = data.data.total
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.ProgrammeData()
    },
    /**
     * 跳转新建计划页面
     */
    toSchemeAdd() {
      this.$router.push(`/plant/scheme/add`)
    },
    toSchemeEdit(id) {
      this.$router.push(`/plant/scheme/edit/${id}`)
    },
    deleteRow(id) {
      delProgrammeData(id).then((data) => {
        this.ProgrammeData()
      })
    },
    showactivate(a) {
      this.activate = a
      //  (this.activate = a)
    },
  },
  mounted() {
    this.ProgrammeData()
  },
  beforeDestroy() {},
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/plant/programme/SchemeList.vue